import config from '../../config/config';
import { createQueryParams } from '@nexio/emvio-util-app';
import { buildTableSuccessActionBasedOnCount } from '../../utils/actionCreators';

export const RESERVE_ACTIVITIES_LOAD = 'RESERVES/RESERVE_ACTIVITIES_LOAD';
export const RESERVE_ACTIVITIES_SUCCESS = 'RESERVES/RESERVE_ACTIVITIES_SUCCESS';
export const RESERVE_ACTIVITIES_FAILURE = 'RESERVES/RESERVE_ACTIVITIES_FAILURE';
export const RESERVE_SUMMARIES_FAILURE = 'RESERVES/RESERVE_SUMMARIES_FAILURE';
export const RESERVE_SUMMARIES_LOAD = 'RESERVES/RESERVE_SUMMARIES_LOAD';
export const RESERVE_SUMMARIES_SUCCESS = 'RESERVES/RESERVE_SUMMARIES_SUCCESS';

const serviceUrl = config.reserveApiUrl;

export const RESERVE_MESSAGE_SESSION_KEY = 'reserveMessageSeen';

export function hasSeenReserveMessageThisSession() {
    try {
        return window.sessionStorage.getItem(RESERVE_MESSAGE_SESSION_KEY) === '1';
    } catch (error) {
        return false;
    }
}

export function markReserveMessageSeenThisSession() {
    try {
        window.sessionStorage.setItem(RESERVE_MESSAGE_SESSION_KEY, '1');
    } catch (error) {
        // sessionStorage can throw in private browsing
    }
}

export function getReserveActivities(filters, page, pageSize, sorters, merchantIds, columns) {
    const queryParamsString = createQueryParams({
        dateKey: 'reportDate',
        filters,
        merchantIds,
        page,
        pageSize,
        sorters,
        columns
    });

    return {
        failureActionTypeOrCreator: getReserveActivitiesFailureActionCreator,
        fetchParams: {
            url: `${serviceUrl}${queryParamsString}`
        },
        loadActionTypeOrCreator: RESERVE_ACTIVITIES_LOAD,
        successActionTypeOrCreator: getReserveActivitiesSuccessActionCreator
    };
}

export function getReserveActivitiesSuccessActionCreator(results) {
    return buildTableSuccessActionBasedOnCount(results, RESERVE_ACTIVITIES_SUCCESS, 'reserveActivities');
}

export function getReserveActivitiesFailureActionCreator(error) {
    return {
        error,
        type: RESERVE_ACTIVITIES_FAILURE
    };
}

export function getReserveSummaries(merchantIds) {
    const queryParamsString = createQueryParams({
        merchantIds
    });

    return {
        failureActionTypeOrCreator: getReserveSummariesFailureActionCreator,
        fetchParams: {
            url: `${serviceUrl}/summary${queryParamsString}`
        },
        loadActionTypeOrCreator: RESERVE_SUMMARIES_LOAD,
        successActionTypeOrCreator: getReserveSummariesSuccessActionCreator
    };
}

export function getReserveSummariesSuccessActionCreator(summaries) {
    return {
        summaries: summaries,
        type: RESERVE_SUMMARIES_SUCCESS
    };
}

export function getReserveSummariesFailureActionCreator(error) {
    return {
        error,
        type: RESERVE_SUMMARIES_FAILURE
    };
}
